@if (isActiveFeature && isAuthenticated()) {
  <!-- .no-style required to not use important in css -->
  <button
    class="chat-bot__button-border"
    (click)="toggleChat()">
    <div class="chat-bot__button">
      <mat-icon>auto_awesome</mat-icon>
      <span>
        {{ 'chat-bot.actions.sidebar-button-label' | translate }}
      </span>
    </div>
  </button>
}
